@for (a of groupedActions() | keyvalue; track a.key; let i = $index) {
  @if (a.value[0].confirm; as message) {
    <app-confirm-action class="list-action"
                        [message]="message"
                        [action]="apply$(a.value)"
                        [appTitle]="a.value">{{ a.key }}</app-confirm-action>
  } @else {
    <app-inline-button class="list-action"
                       [action]="apply$(a.value)"
                       [appTitle]="a.value">{{ a.key }}</app-inline-button>
  }
}
@if (advanced() || showDownload() || mediaAttachment()) {
  <span class="fake-link show-more"
        (click)="showAdvanced($event)">…</span>
  <ng-template #actionsMenu>
    <div class="context-menu advanced-actions" (click)="$event.stopPropagation()">
      @if (showDownload()) {
        <a class="fake-link"
           (click)="download()" i18n>download</a>
      }
      @if (mediaAttachment()) {
      <a class="fake-link"
         (click)="downloadMedia()" i18n>media</a>
      }
      @if (groupedAdvancedActions()) {
        @for (a of groupedAdvancedActions() | keyvalue; track a.key) {
          @if (a.value[0].confirm; as message) {
            <app-confirm-action [message]="message"
                                [action]="apply$(a.value)"
                                [appTitle]="a.value">{{ a.key }}</app-confirm-action>
          } @else {
            <app-inline-button [action]="apply$(a.value)"
                               [appTitle]="a.value">{{ a.key }}</app-inline-button>
          }
        }
      }
    </div>
  </ng-template>
} @else if (showDownload()) {
  <a class="fake-link"
     (click)="download()" i18n>download</a>
}
